import React from 'react'

import { Button, ButtonBase, Container } from '@mui/material';
import roxarImage from '../assets/Home_screen/home_roxar_image.png'
import adaptabiltyIcon from '../assets/Home_screen/home_icon_adaptability.png'
import expertiseIcon from '../assets/Home_screen/home_icon_expertise.png'
import costIcon from '../assets/Home_screen/home_icon_cost.png'
import dataIcon from '../assets/Home_screen/home_icon_data_quality.png'
import { Link } from 'react-router-dom'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

 

const Home = ()=>{
  return(
    <div maxWidth='md' className='home_content'>
        <div className='main_menu' >
          <div className='learn_more_column'>
            <p>¿Qué valor puede aportar un caudalímetro multifásico (MPFM) Roxar 2600 a mis operaciones de producción aguas arriba?</p>
            <Button className='forward_button learn_more_button' component={Link} to={'/adaptability'}>Más información &nbsp;  <ArrowForwardIosIcon/> </Button>
          </div>
          <div className='image_column'>
            <img src={roxarImage} />
          </div>
          <div className='nav_column'>
            <p>Haga clic en una de las siguientes secciones para empezar a explorar áreas para mejorar sus opciones.</p>
            <div className='nav_container'>
              <ButtonBase className='main_nav' component={Link} to={'/adaptability'}>
                <div className='nav_icon_container'>
                  <img src = {adaptabiltyIcon}/>
                  </div>
                <p>Adaptabilidad y escalabilidad</p>
              </ButtonBase>
              <ButtonBase className='main_nav' component={Link} to={'/data'}>
                <div className='nav_icon_container'>
                  <img src = {dataIcon}/>
                  </div>
                <p>Calidad de datos e información de producción</p>
              </ButtonBase>
            </div>
            <div className='nav_container'>
              <ButtonBase className='main_nav' component={Link} to={'/expertise'}>
                <div className='nav_icon_container'>
                  <img src = {expertiseIcon}/>
                  </div>
                <p>Disponibilidad de conocimientos técnicos</p>
              </ButtonBase>
              <ButtonBase className='main_nav' component={Link} to={'/cost'}>
                <div className='nav_icon_container'>
                <img src = {costIcon}/>
                </div>
                <p>Ahorros de costos</p>
              </ButtonBase>
            </div>
          </div>

        </div>
      </div>
      )
    }

    export default Home